import React from 'react'
import Icon from './Icon'
import Header from './Header'
import Accordion from 'react-bootstrap/Accordion'


export default function AccordionTable(props) {

	return (

		<div class={props.layoutClass}>

			{props.data.map(( accordion ) => 
                        
	            <div>

					{accordion.fields.accordion_item.map(( accordion_item ) => 

						<div>

							<Accordion defaultActiveKey="0">

			                    <Accordion.Item eventKey="0">

				                   <Accordion.Header class="accordionHeader" id={accordion_item.subsection_id}>

					                    <Icon src={accordion_item.icon}/>
					                    {accordion_item.subheader}

				                    </Accordion.Header>

			    					<Accordion.Body>

										<div dangerouslySetInnerHTML={{ __html: accordion_item.main_text }} />

									</Accordion.Body>

								</Accordion.Item>
			                	
			                </Accordion>

						</div>

	                )}

	            </div>
	                                             
	        )}

	    </div>

	)

}